
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    //checkOperationResult,
    setOperationError,
    //setOperationStart
} from '../common/client/sagas/common';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const CLOSE_ACTION_TYPE = 'info/CLOSE';
export const SHOW_ACTION_TYPE = 'info/SHOW';
export const SET_ACTUAL_OBJECT_SELECTED = 'info/SET_ACTUAL_OBJECT_SELECTED';
export const SET_OBJECT_INFO = 'info/SET_OBJECT_INFO';

export const GET_OBJECT_INFO_ACTION_TYPE = createActionTypes('info/GET_OBJECT_INFO');
export const GET_OBJECT_FROM_MAP_ACTION_TYPE = createActionTypes('info/GET_OBJECT_FROM_MAP');
export const GET_OBJECT_OPSUB_ACTION_TYPE = 'info/GET_OBJECT_OPSUB';
export const GET_OBJECT_PARCELA_ACTION_TYPE = 'info/GET_OBJECT_PARCELA';
export const GET_OBJECT_TELESO_ACTION_TYPE = 'info/GET_OBJECT_TELESO';

export default function getActions(dispatch) {
    return {
        close: () => dispatch({
            type: CLOSE_ACTION_TYPE
        }),
        getObjectFromMap: (token, id, geom) => dispatch({
            type: GET_OBJECT_FROM_MAP_ACTION_TYPE.DEFAULT, token, id, geom
        }),
        getObjectOpsub: (token, id, opsubId) => dispatch({
            type: GET_OBJECT_OPSUB_ACTION_TYPE, token, id, opsubId
        }),
        getObjectParcela: (token, id, parId) => dispatch({
            type: GET_OBJECT_PARCELA_ACTION_TYPE, token, id, parId
        }),
        getObjectTeleso: (token, id, telId) => dispatch({
            type: GET_OBJECT_TELESO_ACTION_TYPE, token, id, telId
        }),
        setActualObjectSelected: (selected) => dispatch({
            type: SET_ACTUAL_OBJECT_SELECTED, selected
        }),
        setObjectInfo: (data) => dispatch({
            type: SET_OBJECT_INFO, data
        }),
        show: () => dispatch({
            type: SHOW_ACTION_TYPE
        }),
    };
}

function getObjectFromMap(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'getObjectFromMap',
            token: action.token,
            body: {
                id: action.id,
                geom: action.geom
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function getObjectOpsub(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'getObjectOpsub',
            token: action.token,
            body: {
                id: action.id,
                opsubId: action.opsubId
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function getObjectParcela(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'getObjectParcela',
            token: action.token,
            body: {
                id: action.id,
                parId: action.parId
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function getObjectTeleso(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'getObjectTeleso',
            token: action.token,
            body: {
                id: action.id,
                telId: action.telId
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workGetObjectFromMap(options, action) {
    try {
        yield call(clearActionType);
        //yield call(setOperationStart, GET_OBJECT_FROM_MAP_ACTION_TYPE);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(getObjectFromMap, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
        //yield call(checkOperationResult, data.result, GET_OBJECT_FROM_MAP_ACTION_TYPE);
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectFromMap(options) {
    yield takeEvery(GET_OBJECT_FROM_MAP_ACTION_TYPE.DEFAULT, workGetObjectFromMap, options);
}

function* workGetObjectOpsub(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(getObjectOpsub, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectOpsub(options) {
    yield takeEvery(GET_OBJECT_OPSUB_ACTION_TYPE, workGetObjectOpsub, options);
}

function* workGetObjectParcela(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(getObjectParcela, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectParcela(options) {
    yield takeEvery(GET_OBJECT_PARCELA_ACTION_TYPE, workGetObjectParcela, options);
}

function* workGetObjectTeleso(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(getObjectTeleso, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectTeleso(options) {
    yield takeEvery(GET_OBJECT_TELESO_ACTION_TYPE, workGetObjectTeleso, options);
}
